import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from '../../utils/classnames';

export interface ErrorMessageProps {
  title?: string;
  message: string;
  retry?: () => void;
  action?: React.ReactNode;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = 'Something needs attention',
  message,
  retry,
  action,
  className,
}) => {
  return (
    <div
      className={cn(
        'rounded-lg border border-red-200 bg-red-50 p-4 shadow-sm dark:border-red-900 dark:bg-red-950/60',
        className
      )}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-500 dark:text-red-300" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-semibold text-red-900 dark:text-red-100">{title}</h3>
          <div className="mt-2 text-sm leading-6 text-red-800 dark:text-red-200">{message}</div>
          {retry && (
            <div className="mt-4">
              <button
                type="button"
                onClick={retry}
                className="rounded-md border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 dark:border-red-800 dark:bg-red-950 dark:text-red-100 dark:hover:bg-red-900"
              >
                Try again
              </button>
            </div>
          )}
          {action && (
            <div className="mt-4">
              {action}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
